import React from 'react';

import Card from '../card';

export default function StudentInfo({ t, studentInfo = {} }) {
  const studentInfoFields = [
    {
      label: t('cms.table.column.name'),
      value: `${studentInfo?.passportFirstName} ${studentInfo?.passportMiddleName ?? ''} ${
        studentInfo?.passportLastName
      }`,
    },
    {
      label: t('cms.reconciliation.landlord.table.emailAddress'),
      value: studentInfo.emailAddress,
    },
    {
      label: t('cms.landlord.contact.contact_phone.label'),
      value: studentInfo.phoneNumber,
    },
  ];
  return (
    <Card
      title={t('cms.reconciliation.lead_generation.detail.student_info.title')}
      dataSet={studentInfoFields}
    />
  );
}
